<div class="spinner-wrapper" 
    [ngStyle]="{'padding': boxPadding, 'font-size': boxFont, 'color': boxColour, width: boxWidth}">
  <i class="fa fa-spinner fa-spin" 
    [ngStyle]="{'font-size': faFont, 'color': faColour}"></i>  &nbsp;  {{spinnerMessage}}
   <!-- We add a message here for printable versions of the content - do not change the wording as the PDF generation relies on this. --> 
  <span class="d-none d-print-block">Content has not fully loaded.</span>
</div>